import "./lib/workspacePublicPath";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Benign browser warning fired by the canvas / iframe / flow-layout work that
// the CRA dev overlay would otherwise surface as a fatal error and block the
// UI behind a red screen. Swallowed in dev only in effect — in a production
// build there is no overlay to block.
const RO_RE = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (e) => {
  if (e?.message && RO_RE.test(e.message)) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
